module.exports = __webpack_public_path__ + "static/media/Greenbriar_Master_Deed.dc87bd98.pdf";